// extracted by mini-css-extract-plugin
var _1 = "HeroBanner_wrapperBanner__9v7zb";
export { _1 as "wrapperBanner" }
